module.exports = __webpack_public_path__ + "static/logo-0379688f3dde7c5e25adcff6c71bdd9c.png";